<template>
    <div class="c-loader-parent">
        <div class="c-loader" :class="[size ? `c-loader--${size}` : '', type ? `c-loader--${type}` : '']"></div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            size: String,
            type: String,
        },
        components: {},
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-loader {

    }

    .c-loader--circle {
        @keyframes spin {
            to {
                transform: rotate(360deg);
            }
        }

        width: em(40px);
        height: em(40px);
        border-radius: 50%;
        border: 2px dashed $color-alpha;
        animation: .5s spin linear forwards infinite;

        &.c-loader--small {
            $size: em(20px);
            width: $size;
            height: $size;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/loader/Loader.vue